module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("添加频道信息，说出频道名称即可换台~")]), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": "",
      "title": '频道名称',
      "value": _vm.channelData.channelName
    },
    nativeOn: {
      "click": function($event) {
        _vm.gotoChannelSelect($event)
      }
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "placeholder": "频道台号",
      "keyboard": "number",
      "show-clear": false,
      "placeholder-align": "left"
    },
    model: {
      value: (_vm.channelData.channelCode),
      callback: function($$v) {
        _vm.$set(_vm.channelData, "channelCode", $$v)
      },
      expression: "channelData.channelCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "next-btn"
  }, [_c('button', {
    staticClass: "btn-operate-positive",
    on: {
      "click": _vm.saveChannel
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!this.$route.query.customChannelId),
      expression: "!!this.$route.query.customChannelId"
    }],
    staticClass: "btn-operate-negative ",
    style: ({
      marginTop: '0.45rem'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteChannel
    }
  }, [_vm._v("删除频道")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-264634b0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/channel/ChannelAdd.vue
// module id = 880
// module chunks = 1